import { render, staticRenderFns } from "./PhoneComponent.vue?vue&type=template&id=e8228e5c&scoped=true"
import script from "./PhoneComponent.vue?vue&type=script&lang=js"
export * from "./PhoneComponent.vue?vue&type=script&lang=js"
import style0 from "./PhoneComponent.vue?vue&type=style&index=0&id=e8228e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8228e5c",
  null
  
)

export default component.exports